// @flow
import * as React from 'react';
import { ObjectContext } from 'esm-web-pro/containers/map/MapObject';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import Spinner from 'esm-web-pro/components/forms/Spinner';
import { Box } from 'grommet';
import typeof Point12 from './Point12';
import Point12CableList from './CableList/Point12CableList';

type Props = {
    point: Point12,
    cables: Object,
    splices: Object,
    map: Object,
    editor: BaseEditor,
    onView: Function,
    clickedRowIdentity: ?string,
    setClickedRowIdentity: Function,
    getCables: Function,
    highlightFiber: Function,
    highlightFiberCleanUp: Function,
    clearHighlightedFibers: Function,
    setLoadingCallback: Function,
    loading: boolean,
    opticalODFPorts: Object[],
    dataPorts: Object[],
    onReload: Function,
}

const Point12Content = (props: Props) => {
    const {
        point, map, onView, editor, clickedRowIdentity, setClickedRowIdentity, getCables,
        cables, splices, highlightFiber, highlightFiberCleanUp, clearHighlightedFibers, setLoadingCallback, loading,
        opticalODFPorts, dataPorts, onReload,
    } = props;

    const handleGetCables = React.useCallback(() => {
        setLoadingCallback(true);
        getCables(point.uuid, map).then(() => setLoadingCallback(false));
    }, [point, map]);

    return loading ? (
        <Box pad={{ top: 'medium' }}>
            <Spinner
                type="clipLoader"
                loading
                blocking={false}
                color="black"
                coverStyle={{
                    position: 'relative',
                    width: 'auto',
                    height: 'auto',
                }}
            />
        </Box>
    ) : (
        <ObjectContext.Consumer>
            {({ reload }) => (
                <Point12CableList
                    point={point}
                    cables={cables}
                    splices={splices}
                    reload={() => {
                        reload();
                        onReload();
                    }}
                    map={map}
                    getCables={handleGetCables}
                    onView={onView}
                    editor={editor}
                    clickedRowIdentity={clickedRowIdentity}
                    setClickedRowIdentity={setClickedRowIdentity}
                    highlightFiber={highlightFiber}
                    highlightFiberCleanUp={highlightFiberCleanUp}
                    clearHighlightedFibers={clearHighlightedFibers}
                    opticalODFPorts={opticalODFPorts}
                    dataPorts={dataPorts}
                />
            )}
        </ObjectContext.Consumer>
    );
};

export default Point12Content;
